import { initExploreProjects } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/projects/index.js?vue3';

initExploreProjects();
